<template>
    <div v-show="loaded" class="content">
        <Head>
            <link
                rel="shortcut icon"
                :href="page.props.brand.meta_favicon"
            >

            {{ yoastHead }}
        </Head>

        <WatsonOrganismHeader
            v-if="page.props.settings.globalComponents.header"
            :content="page.props.settings.globalComponents.header"
        />

        <slot></slot>

        <WatsonOrganismFooter
            v-if="page.props.settings.globalComponents.footer"
            :content="page.props.settings.globalComponents.footer"
        />

        <WatsonThemeStickyCta
            v-if="page.props.stickyCta && !page.props.stickyCta.disabled"
        />
    </div>
</template>

<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import { nextTick, onBeforeMount, onMounted, ref } from 'vue';
import responsiveBaseSizes from '@utils/responsive-base-sizes';
import { parseBrandSettings } from '../js/utils/brand-settings';

import WatsonOrganismFooter from '@organisms/footer/watson-organism-footer.vue';
import WatsonOrganismHeader from '../../../components/organisms/header/watson-organism-header.vue';
import WatsonThemeStickyCta from '../components/sticky-cta/watson-theme-sticky-cta.vue';

const page = usePage();
const loaded = ref(false);

defineProps({
    yoastHead: {
        type: String,
        required: false,
        default: '',
    },
});

onBeforeMount(() => {
    parseBrandSettings(page.props.brand);
    responsiveBaseSizes();
});

onMounted(() => {
    nextTick(() => {
        loaded.value = true;
    });
});
</script>
